import { FB_EVENTS, sendCustomFBEvent } from 'commons/fbEvents';
import { useEffect, useMemo } from 'react';
import useMetaFormattedCityStateZip from '../useMetaFormattedCityStateZip';

const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';

const useJbEventFBSelectVariation = ({
  basicDetails = DEFAULT_BASIC_DETAILS,
  selectedOptionsVariantSku = DEFAULT_VARIANT_SKU,
}) => {
  const {
    sku: baseSku = '',
    name = '',
    type: { name: productName = '' } = {},
  } = useMemo(() => basicDetails, [basicDetails]);

  const sku = baseSku + selectedOptionsVariantSku;

  const {
    formattedZip: zip,
    formattedCity: city,
    formattedState: state,
  } = useMetaFormattedCityStateZip();

  useEffect(() => {
    if (productName && sku && name) {
      window.jbEventFBSelectVariation = () => {
        sendCustomFBEvent(FB_EVENTS.SELECT_VARIATION, {
          content_category: productName,
          content_ids: [sku],
          content_name: name,
          content_type: 'product',
          zp: zip,
          ct: city,
          st: state,
        });
      };
    } else {
      window.jbEventFBSelectVariation = undefined;
    }
  }, [city, name, productName, sku, state, zip]);
};

export default useJbEventFBSelectVariation;
